import type Device from "./Device";

const DEFAULT_DEVICE_WIDTH_MM = 35;
const DEFAULT_DEVICE_HEIGHT_MM = 90;

export default class DeviceLayoutDefinition {
  constructor(private readonly device: Device) {}

  get widthMm(): number {
    const widthInMillimeter = this.device.template?.knxProductData?.productInfo?.WidthInMillimeter;
    const parsedWidth = widthInMillimeter ? Number.parseFloat(widthInMillimeter) : Number.NaN;
    if (Number.isFinite(parsedWidth) && parsedWidth > 0) {
      return parsedWidth;
    }

    // Fallback for regular DIN rail modules.
    const productInfo = this.device.template?.knxProductData?.productInfo as unknown as Record<
      string,
      string | undefined
    >;
    const widthInTe = productInfo?.WidthInSlots || productInfo?.WidthTE;
    const parsedWidthInTe = widthInTe ? Number.parseFloat(widthInTe) : Number.NaN;
    if (Number.isFinite(parsedWidthInTe) && parsedWidthInTe > 0) {
      return parsedWidthInTe * 17.5;
    }

    return DEFAULT_DEVICE_WIDTH_MM;
  }

  get heightMm(): number {
    return DEFAULT_DEVICE_HEIGHT_MM;
  }

  async getFrontImage(): Promise<string | undefined> {
    const template = this.device.template;
    if (!template) {
      return undefined;
    }

    if (template.knxProductData.frontImageLoaded == false) {
      await template.knxProductData.loadFrontImage();
    }

    if (this.device.frontImage) {
      return this.device.frontImage;
    }
    return undefined;
  }
}
